import { memo, useMemo } from "react";
import * as Styled from "./style";
import { useRouter } from "next/router";
import type { VideoLegacySeasonType } from "~/components/blocks/product/type-guard";
import { PATHS } from "~/const/paths";
import { useHandleClickByDevice } from "~/hooks/use-handle-click-by-device";
import { useImageSrcFormat } from "~/hooks/use-image-src-format";
import { useMatchMedia } from "~/hooks/use-match-media";
import { useQueryString } from "~/hooks/use-query-string";

type SampleMovieProps = {
  videoLegacySeasonData: VideoLegacySeasonType;
};

/** グラビアテンプレのみで使用するサンプル動画タブ押下時に表示するコンポーネント */
export const SampleVideo = memo((props: SampleMovieProps) => {
  const { videoLegacySeasonData } = props;

  const {
    packageImage,
    packageLargeImage,
    sampleMovie,
    content: { id },
  } = videoLegacySeasonData;

  const { push } = useRouter();
  const { season } = useQueryString();
  const { isSpSize } = useMatchMedia();
  const { handleClickByDevice } = useHandleClickByDevice();
  const { imageSrcFormat } = useImageSrcFormat({ aspectRatio: "LANDSCAPE" });

  const sampleImageSrc = useMemo(() => {
    if (sampleMovie === undefined || sampleMovie === null) return "";

    return sampleMovie.thumbnail
      ? sampleMovie.thumbnail
      : packageLargeImage
      ? packageLargeImage
      : packageImage
      ? packageImage
      : "";
  }, [packageImage, packageLargeImage, sampleMovie?.thumbnail]);

  if (sampleMovie === undefined || sampleMovie === null) return null;

  return (
    <Styled.DivContainer>
      <Styled.BtnThumbnailWrapper
        type="button"
        name="サンプル動画を再生するボタン"
        aria-label="サンプル動画を再生するボタン"
        {...handleClickByDevice(async () => {
          void push({
            pathname: PATHS.VOD_PLAYER,
            query: {
              season,
              content: id,
              mode: "sample",
            },
          });
        })}
      >
        {/* // HACK: LazyImageに変更 */}
        <picture>
          <source srcSet={imageSrcFormat({ imgSrc: sampleImageSrc }).src} type="image/webp" />
          <Styled.ImgSample
            src={imageSrcFormat({ imgSrc: sampleImageSrc }).alternativeSrc}
            alt="サンプル画像"
            width={isSpSize ? 128 : 224}
            height={isSpSize ? 72 : 126}
          />
        </picture>

        <Styled.DivIconWrapper>
          <Styled.Icon name="play" size={isSpSize ? "XXL" : "XXXL"} color="GRAY900" />
        </Styled.DivIconWrapper>
      </Styled.BtnThumbnailWrapper>

      <Styled.SecTagRoot>
        <Styled.Heading size={isSpSize ? "S" : "M"}>サンプル動画</Styled.Heading>
      </Styled.SecTagRoot>
    </Styled.DivContainer>
  );
});

SampleVideo.displayName = "SampleVideo";
